import { useEffect, useState } from "react";
import { MESSAGE } from "../../../utils/message";
import Profile from "../../common/profile"; 
import NonprofitReviews from "../../common/nonprofitReviews";
import {
  ReviewsTabSection,
  FundraiserTitle,
  ReviewProfile,
  ProfileImage,
  ReviewText,
} from "./myReviewStyle";
import { useSelector,useDispatch } from "react-redux";
import { userProfileReviewHandler } from "../../../redux/slices/myAccount/userProfileReview-slice";
import { UserStateType } from "../../../utils/types";
import SimpleLoader from "../simpleLoader/Loader";
import { userProfileStatesHandler } from "../../../redux/slices/myAccount/accountDetail-slice";
import { useParams } from "react-router-dom";

const MyReviewsTab = () => {
  const { user_id } = useParams();
  const [loader, setLoader] = useState(true);
  const profileReviews: any = useSelector( 
    (state: any) => state?.userProfileReview
  );
  
  
  const userStates = useSelector(
    (state: UserStateType) => state?.accountDetail?.userState?.results
  );
  const dispatch: any = useDispatch();

  useEffect(() => {
    if (!userStates && user_id) {
      dispatch(userProfileStatesHandler(user_id) as any);
    }
    if (user_id) {
      setLoader(true);
      dispatch(userProfileReviewHandler(user_id))
      .then(() => setLoader(false))
      .catch(() => setLoader(false));
    }
  }, [dispatch,user_id]);

  return (
    <ReviewsTabSection>
      <FundraiserTitle>{MESSAGE.myReviews}</FundraiserTitle>
      {loader ? (
               <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <SimpleLoader />
               </div>
            ) : (
      <ReviewProfile>
        <ProfileImage>
          <Profile profileReviewData={userStates} />
        </ProfileImage>

        <ReviewText>
          
          <NonprofitReviews
            reviewData={profileReviews?.data}
            page="my-account"
          />
        </ReviewText>
      </ReviewProfile>
      )}
    </ReviewsTabSection>
  );
};

export default MyReviewsTab;
